import { render, staticRenderFns } from "./CarreraAgregarForm.vue?vue&type=template&id=ef2281f2"
import script from "./CarreraAgregarForm.vue?vue&type=script&lang=js"
export * from "./CarreraAgregarForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports